// Shared labels + badge tones for the Changelog section.

import type { ChangelogArea, MetricPopulation } from '@/services/changelog';

export const AREA_OPTIONS = [
  { value: 'signup', label: 'Signup' },
  { value: 'pricing', label: 'Pricing' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'forms', label: 'Forms' },
  { value: 'billing', label: 'Billing' },
  { value: 'xray', label: 'X-Ray' },
] as const;

export const AREA_LABELS: Record<ChangelogArea, string> = Object.fromEntries(
  AREA_OPTIONS.map((o) => [o.value, o.label]),
) as Record<ChangelogArea, string>;

export const formatMetricValue = (
  value: number | null,
  unit: 'percent' | 'count' | 'currency',
): string => {
  if (value === null) return 'n/a';
  if (unit === 'percent') return `${value.toFixed(1)}%`;
  // Cents matter: this is money per signup, tens of dollars, and a price change
  // moves it by single dollars. Big totals drop them again.
  if (unit === 'currency') {
    return value >= 1000
      ? `$${Math.round(value).toLocaleString()}`
      : `$${value.toFixed(2)}`;
  }
  return Math.round(value).toLocaleString();
};

/** Every metric counts accounts unless the API says otherwise (trials, for Trial to paid). */
export const ACCOUNTS: MetricPopulation = { one: 'account', many: 'accounts', newest: 'Accounts created' };

/** "1 trial" / "12 trials": the count behind a point or a bar, in the metric's own unit. */
export const countLabel = (n: number, population: MetricPopulation = ACCOUNTS): string =>
  `${n} ${n === 1 ? population.one : population.many}`;
